import { Component, computed, input } from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { SectionBgClass } from '@valk-nx/core/lib/pipes/section-class/section-class.pipe';
import type { BackgroundColors } from '@valk-nx/core/lib/pipes/section-class/section-class.types';
import { CardComponent } from '@valk-nx/storyblok/components/card/src/lib/card';
import { ColumnsComponent } from '@valk-nx/storyblok/components/columns/src/lib/columns';
import { PackageCardComponent } from '@valk-nx/storyblok/components/package-card/src/lib/package-card';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import {
	HeadingGroupSection,
	ISbStoryBlok,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

const Components = {
	card: CardComponent,
	packageCard: PackageCardComponent,
};

@Component({
	selector: 'sb-card-section',
	templateUrl: './card-section.html',
	imports: [
		ColumnsComponent,
		DynamicModule,
		SectionBgClass,
		StoryblokDirective,
	],
})
export class StoryblokCardSectionComponent extends StoryblokRootDirective {
	cards = input<ISbStoryBlok[] | undefined>(undefined);
	title = input.required<HeadingGroupSection[]>();
	sectionBackgroundClass = input<BackgroundColors>('gradient-50');

	titleInput = computed<(InputsType & { component: string })[]>(() => {
		if (typeof this.title() !== 'string') {
			return (
				this.title()?.map((blok) => ({
					...blok,
					component: blok?.['component'] ?? '',
					maxWidth: 'max-w-screen-xl',
				})) ?? []
			);
		}

		return [];
	});

	cardGridSize = computed(() => {
		const cardCount = this.cards()?.length;

		switch (cardCount) {
			case 1:
				return 'grid-cols-1';
			case 2:
				return 'grid-cols-1 md:grid-cols-2';
			default:
				return 'grid-cols-1 md:grid-cols-3';
		}
	});

	readonly components: typeof Components = Components;
}
